import * as React from 'react';
import {
  TicketsTemplateFormatType,
  TicketTemplateElementType
} from '../../../models/chatChannelModel/message/format';
import {styled} from '../../../utils';
import Flex from '../../Flex';
import Text from '../../Text';
import ChatMessage from '../ChatMessage';

interface TicketsMessageProps {
  message: ChatMessage<TicketsTemplateFormatType>;
}

const Box = styled('div')({
  border: '1px solid gray',
  marginRight: 3,
  marginTop: 3,
  borderRadius: 5,
  textAlign: 'center',
  padding: 10
});

class TicketElement extends React.Component<
  {ticket: TicketTemplateElementType},
  {}
> {
  public render() {
    return (
      <Box>
        <Flex direction="column">
          <Text fontSize={14} style={{fontWeight: 'bold'}}>
            {this.props.ticket.title}
          </Text>
          <Text fontSize={12}>{this.props.ticket.subtitle}</Text>
        </Flex>
      </Box>
    );
  }
}

export default class TicketsMessage extends React.Component<
  TicketsMessageProps,
  {}
> {
  public render() {
    const tickets = this.props.message.format.attachment.payload.elements;
    return (
      <Flex style={{marginLeft: 60}}>
        {tickets.map((ticket, idx) => {
          return <TicketElement ticket={ticket} key={idx} />;
        })}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/TicketsMessage/TicketsMessage.tsx